import * as React from 'react';
import {ApplicationState} from "../../store";
import {InvoiceItem, InvoiceItemDescriptor} from '../../models/InvoiceItem';
import {
	ListItem, Avatar, List, ListSubheader, TextField, ListItemText, ListItemAvatar, Collapse,
	ListItemSecondaryAction, IconButton, FormControl, InputLabel, Select, MenuItem, FormHelperText
} from '@material-ui/core';
import {Utility} from '../../core/Utility';
import {actionSetTabState} from '../../store/tabs/actions';
import {connect} from 'react-redux';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import DeleteIcon from '@material-ui/icons/Delete';
import SaveIcon from "@material-ui/icons/Save"
import {DeleteConfirmation} from "../components/DeleteConfirmation";
import {Validator} from "../../core/Validator";
import {Service, unitTypes} from "../../models/Service";
import {ChangeEvent} from "react";
import {actionServiceFetchAll} from "../../store/services";
import {actionInvoiceItemDelete, actionInvoiceItemSave} from "../../store/invoices";
import {t} from "../../core/localization";
import ServicesService from "../../services/ServicesService";

export interface InvoiceItemsFormProps {
	item?: any
	state?: any
	services: Service[]
}

export interface InvoiceItemsFormState {
	isDeleteConfirmationDialogOpen: boolean;
	positionOfItemToDelete?: number;
	validation: any;
}

function mapStateToProps(state: ApplicationState) {
	return {
		state: state.tabs.active.state,
		item: state.tabs.active.item,
		services: state.services.list
	};
}

class InvoiceItemsForm extends React.Component<InvoiceItemsFormProps, InvoiceItemsFormState> {

	constructor(props: InvoiceItemsFormProps){
		super(props);
		this.state = {isDeleteConfirmationDialogOpen: false, validation: { valid: true, fields: [] }}
	}

	componentWillReceiveProps(nextProps: InvoiceItemsFormProps) {
	}

	componentDidMount() {
		actionServiceFetchAll()
	}

	onSelectChange(value: number, listItem: any): void{

		let item: any = this.props.item
		let tabState = this.props.state

		if (!tabState['item']) tabState['item'] = Utility.clone(item)
		let selectedInvoiceItemNumber = tabState['item']['selectedInvoiceItemNumber']

		if(selectedInvoiceItemNumber === value)
			tabState['item']['selectedInvoiceItemNumber'] = undefined
		else
			tabState['item']['selectedInvoiceItemNumber'] = value

		actionSetTabState(tabState)
	}

	handleItemTextInputChange(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>, key: string) {
		let item: any = this.props.item
		let tabState = this.props.state

		if (!tabState['item']) tabState['item'] = Utility.clone(item)

		let selectedInvoiceItemNumber = tabState['item']['selectedInvoiceItemNumber']
		if(selectedInvoiceItemNumber !== undefined)
			tabState['item']['invoiceItems'][selectedInvoiceItemNumber][key] = e.target.value
		actionSetTabState(tabState)
	}

	protected handleItemSelectChange(e: ChangeEvent<{ name?: string; value: unknown }>, key: string) {
		let item: any = this.props.item
		let tabState = this.props.state

		if (!tabState['item']) tabState['item'] = Utility.clone(item)

		let selectedInvoiceItemNumber = tabState['item']['selectedInvoiceItemNumber']
		if(selectedInvoiceItemNumber !== undefined)
			tabState['item']['invoiceItems'][selectedInvoiceItemNumber][key] = e.target.value

		if (key == "serviceId") {
			// todo: set default service values to inovice item
			const service: Service = this.props.services.find((s: Service) => {return s.id == e.target.value} )
			tabState['item']['invoiceItems'][selectedInvoiceItemNumber]['unitPrice'] = service.price
			tabState['item']['invoiceItems'][selectedInvoiceItemNumber]['unitName'] = ServicesService.unitForInvoice(service.unitName as any)
			tabState['item']['invoiceItems'][selectedInvoiceItemNumber]['title'] = service.title

			// tabState['item']['invoiceItems'][selectedInvoiceItemNumber]['vat'] = service.vat
			// actionSetTabState(tabState)
			console.log(e.target.value)
		}
		actionSetTabState(tabState)
	}

	getItemFromTabState (key?: string) {
		let tabState = this.props.state
		if (tabState['item']) {
			if (!key) return tabState['item']
			else if (!Utility.isNullOrUndefined(tabState['item'][key])) return tabState['item'][key]
		}
		if (!key) return this.props.item
		else return this.props.item[key]
	}

	getInvoiceItemFromTabState (key?: string, position?: number) {
		let tabState = this.props.state
		if (tabState['item']) {
			if (!key) return tabState['item']
			else if (!Utility.isNullOrUndefined(tabState['item']['invoiceItems'][position][key])) return tabState['item']['invoiceItems'][position][key]
		}

		if (!key) return this.props.item
		else if(this.props.item['invoiceItems'] && this.props.item['invoiceItems'][position])
			return this.props.item['invoiceItems'][position][key]
	}

	onSaveInvoiceItem(value: number): void{

		let item = this.getItemFromTabState()
		let invoiceItem = item.invoiceItems[value]
		let validation: any = Validator.validateItemWithErrorTypes(invoiceItem, InvoiceItemDescriptor)

		if (validation.valid) {
			actionInvoiceItemSave(invoiceItem, value)
		}

		this.setState({ ...this.state, validation: validation });
	}

	onToggleDeleteConfirmationModal() {
		this.setState({ ...this.state, isDeleteConfirmationDialogOpen: !this.state.isDeleteConfirmationDialogOpen, positionOfItemToDelete: undefined});
	}

	openDeleteConfirmationModal(position: number) {
		this.setState({ ...this.state, isDeleteConfirmationDialogOpen: true, positionOfItemToDelete: position});
	}

	onDeleteConfirmClick(){
		let item = this.getItemFromTabState()

		if(this.state.positionOfItemToDelete !== undefined){

			let invoiceItem = item.invoiceItems[this.state.positionOfItemToDelete]
			if(invoiceItem) {
				// actionInvoiceItemDelete(invoiceItem)

				item.invoiceItems.splice(this.state.positionOfItemToDelete, 1)
				let tabState = this.props.state

				tabState['item'] = item
				this.onToggleDeleteConfirmationModal()
				if(invoiceItem.id) {
					actionInvoiceItemDelete(invoiceItem)
				}
				actionSetTabState(tabState)
			}
		}
	}

	render(): React.ReactNode{
		return <div>
			{this.renderInvoiceItems()}
			{this.renderDeleteConfirmationDialog()}
		</div>
	}

	renderDeleteConfirmationDialog(): React.ReactNode {
		return <DeleteConfirmation
			isOpen={this.state.isDeleteConfirmationDialogOpen}
			onDeleteConfirm={this.onDeleteConfirmClick.bind(this)}
			onToggleModal={() => this.onToggleDeleteConfirmationModal()}
		/>
	}

	renderInvoiceItems(): React.ReactNode{

		let item = this.getItemFromTabState()

		var invoiceItems: InvoiceItem[] = item.invoiceItems,
			listItems = [];
		if(invoiceItems){

			for (var i=0; i<invoiceItems.length; i++) {
				var invoiceItem = invoiceItems[i],
					selected = item['selectedInvoiceItemNumber'] === i,
					firstLetter = invoiceItem.title ? invoiceItem.title.charAt(0) : '';

				listItems.push(<div key={String(i)}>
						<ListItem
							key={String(i)}
							onClick={this.onSelectChange.bind(this, i)}
							selected={selected}
						>
							<ListItemAvatar>
								<Avatar>{firstLetter}</Avatar>
							</ListItemAvatar>

							<ListItemText primary={invoiceItem.title} />

							<ListItemSecondaryAction>

								<IconButton onClick={this.onSaveInvoiceItem.bind(this, i)} edge="end" aria-label="delete">
									<SaveIcon />
								</IconButton>

								<IconButton onClick={this.openDeleteConfirmationModal.bind(this, i)} edge="end" aria-label="delete">
									<DeleteIcon />
								</IconButton>

								<IconButton onClick={this.onSelectChange.bind(this, i)} edge="end" aria-label="delete">
									{selected ? <ExpandLess /> : <ExpandMore />}
								</IconButton>

							</ListItemSecondaryAction>

						</ListItem>
						<Collapse in={selected} timeout="auto" unmountOnExit>

							<List disablePadding>
								<FormControl required style={{width: '100%', padding: "15px", marginTop: "10px", position: "relative"}} >
									<InputLabel htmlFor="serviceId" style={{left: "auto"}}>{t.Service}</InputLabel>
									<Select
										value={Utility.formatString(this.getInvoiceItemFromTabState('serviceId', i))}
										onChange={(e) => {this.handleItemSelectChange(e, 'serviceId')}}
										name="serviceId"
										required={true}
										error={Validator.displayFormErrors(this.state.validation.fields, 'serviceId').show}
										style={{width: '100%'}}>
										{this.props.services.map((component, key) => (
											<MenuItem key={key} value={component.id}>{component.title}</MenuItem>
										))}
									</Select>
									<FormHelperText style={{color: '#ed1a3a'}}>{Validator.displayFormErrors(this.state.validation.fields, 'serviceId').message}</FormHelperText>
								</FormControl>
								<ListItem key="title">
									<TextField
										label={t.Title}
										value={Utility.formatString(this.getInvoiceItemFromTabState('title', i))}
										onChange={(e) => {this.handleItemTextInputChange(e, 'title')}}
										margin="normal"
										fullWidth
										required={true}
										error={Validator.displayFormErrors(this.state.validation.fields, 'title').show}
										helperText={Validator.displayFormErrors(this.state.validation.fields, 'title').message}
									/>
								</ListItem>
								<ListItem key="amount">
									<TextField
										label={t.UnitAmount}
										value={Utility.formatString(this.getInvoiceItemFromTabState('amount', i))}
										onChange={(e) => {this.handleItemTextInputChange(e, 'amount')}}
										margin="normal"
										fullWidth
										required={true}
										error={Validator.displayFormErrors(this.state.validation.fields, 'amount').show}
										helperText={Validator.displayFormErrors(this.state.validation.fields, 'amount').message}
									/>
								</ListItem>
								<ListItem key="unitPrice">
									<TextField
										label={t.PricePerUnit}
										value={Utility.formatString(this.getInvoiceItemFromTabState('unitPrice', i))}
										onChange={(e) => {this.handleItemTextInputChange(e, 'unitPrice')}}
										margin="normal"
										fullWidth
										required={true}
										error={Validator.displayFormErrors(this.state.validation.fields, 'unitPrice').show}
										helperText={Validator.displayFormErrors(this.state.validation.fields, 'unitPrice').message}
									/>
								</ListItem>
								<ListItem key="unitName">
									<TextField
										label={t.UnitName}
										value={Utility.formatString(this.getInvoiceItemFromTabState('unitName', i))}
										onChange={(e) => {this.handleItemTextInputChange(e, 'unitName')}}
										margin="normal"
										fullWidth
										required={true}
										error={Validator.displayFormErrors(this.state.validation.fields, 'unitName').show}
										helperText={Validator.displayFormErrors(this.state.validation.fields, 'unitName').message}
									/>
								</ListItem>
								<ListItem key="vat">
									<TextField
										label={t.Vat}
										value={Utility.formatString(this.getInvoiceItemFromTabState('vat', i))}
										onChange={(e) => {this.handleItemTextInputChange(e, 'vat')}}
										margin="normal"
										fullWidth
										required={true}
									/>
								</ListItem>
							</List>
						</Collapse>
					</div>
				);
			}
		}

		return <List>
			<ListSubheader>{t.Services}</ListSubheader>
			{listItems}
		</List>
	}

}

// export default compose(
// 	connect(mapStateToProps),
// 	withStyles(GlobalStyles)
// )(InvoiceItemsForm);

export default connect(mapStateToProps)(InvoiceItemsForm);
